import { MediaDisplay } from ".";
import _ from "lodash";
import * as React from "react";
import * as Comp from "../../../components";
import * as M from "../../../models";
import { Utility } from "../../../utils";

interface OwnProps {
    abstract: M.Abstract.AbstractForGrader;
    type: M.Abstract.AbstractType;
}

interface OwnState {
}

export class AbstractSummaryForGrader extends React.Component<OwnProps, OwnState> {
    public render() {
        const a = this.props.abstract;

        const classification = this.props.type.classifications.length
            ? <Comp.Editors.ReviewFieldAsDefListItem label="Classification">{a.classification || <p><em>None</em></p>}</Comp.Editors.ReviewFieldAsDefListItem>
            : null;

        // display form fields and media as described by the
        // abstract type's gradingFieldDisplay array.
        let formDetails: any = null;
        if (this.props.type.form) {
            const allFields: M.FormBuilder.Field[] = [];
            const submission = this.props.abstract.details;
            for (const s of this.props.type.form.sections)
                for (const f of s.fields)
                    allFields.push(f);

            formDetails = _.orderBy(this.props.type.displayFields, "sort")
                .filter((fd) => fd.uiTypeId === M.Abstract.DisplayUITypes.Grader.id)
                .map((fd, i) => {
                    if (fd.formFieldId) {
                        const field = _.find(allFields, (x) => x.fieldId === fd.formFieldId);
                        if (field) {
                            const value = submission
                                ? _.find(submission.answers, (answer) => answer.fieldId === field.fieldId)
                                : undefined;

                            const fieldDisplay = M.FormBuilder.FormSubmissionHelper.getFieldValueDisplay(field, value ? value.answer : undefined);
                            const label = fd.labelOverride || field.metaData.label;

                            return <Comp.Editors.ReviewFieldAsDefListItem key={i} label={label} isHtml={fieldDisplay.isHtml}>
                                    {fieldDisplay.value}
                                </Comp.Editors.ReviewFieldAsDefListItem>;
                        }
                    }
                    else if (fd.abstractTypeMediaId) {
                        const tm = _.find(this.props.type.typeMedia, (x) => x.id === fd.abstractTypeMediaId);
                        if (tm) {
                            const media = a.media.filter((m) => m.abstractTypeMediaId === tm.id);
                            if (media.length) {
                                return media.map((m, j) => {
                                    const caption = tm.promptCaption && m.caption
                                        ? <p className="mute" dangerouslySetInnerHTML={{ __html: m.caption }} />
                                        : null;

                                    const keywords = tm.promptKeywords && m.tags.length
                                        ? <p className="mute">{Utility.joinSkipEmpty(m.tags.map((t) => t.name), ", ")}</p>
                                        : null;

                                    const label = fd.labelOverride || tm.label;

                                    return <Comp.Generic.WrapperLess key={j}>
                                        <Comp.Editors.ReviewFieldAsDefListItem label={label}>
                                            <MediaDisplay hideFilename media={m} />
                                            {caption}
                                            {keywords}
                                        </Comp.Editors.ReviewFieldAsDefListItem>
                                    </Comp.Generic.WrapperLess>;
                                    });
                            }
                            else
                                return <Comp.Editors.ReviewFieldAsDefListItem key={i} label={tm.label}><p><em>None</em></p></Comp.Editors.ReviewFieldAsDefListItem>;
                        }

                        return null;
                    }

                    return null;
                });
        }

        const details = classification !== null || formDetails !== null
            ? <Comp.Generic.WrapperLess>
                {classification}
                {formDetails}
            </Comp.Generic.WrapperLess>
            : null;

        return <Comp.Generic.WrapperLess>
            <Comp.Editors.ReviewFieldAsDefListItem label="Title" isHtml>{a.title}</Comp.Editors.ReviewFieldAsDefListItem>
            <Comp.Editors.ReviewFieldAsDefListItem label="Presentation format">{a.type}</Comp.Editors.ReviewFieldAsDefListItem>
            {details}
        </Comp.Generic.WrapperLess>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/components/AbstractSummaryForGrader.tsx